module.exports = __webpack_public_path__ + "static/media/banner775f8cc8f0109d616cb15c1e4c2360ca.webp";